export default __webpack_public_path__ + "static/content-1-mobile_2-d55c5d4a3eb8d36a760c52eec7f07eea.png";